module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"errorSeries":"An error occured, please reload the series list","reload":"Reload"},"fr":{"errorSeries":"Une erreur est survenue, veuillez recharger les séries.","reload":"Recharger"}}')
  delete Component.options._Ctor
}
